import {post} from '@/utils/request';

// 新增数据
export function DepartmentsAdd(Data) {
  return post('/Departments/Add', Data); 
}
// 修改数据
export function DepartmentsUpdate(Data) {
  return post('/Departments/Update', Data); 
}
// 删除数据
export function DepartmentsDel(Data) {
  return post('/Departments/Del', Data); 
}
// 数据列表
export function DepartmentsList(Data) {
  return post('/Departments/List', Data); 
}
// 下拉获取部门信息
export function DepartmentsPullDown(Data) {
  return post('/Departments/PullDown', Data); 
}

